var app = angular.module('leonardo');

var DynamicFormSelector = function(DynamicFormRestService, AuthDataService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/dynamic-form-selector.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];

      scope.data = {};
      var filters = {disable_pagination: true};
      if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
        filters['account_empty'] = 1;
      }
      DynamicFormRestService.getlist(filters).then(function(data){
        scope.forms = data;
      });

      scope.onValueChange = function() {
        scope.ngModelCtrl.$setViewValue(scope.data.value);
      };

      scope.ngModelCtrl.$render = function() {
        scope.data.value = scope.ngModelCtrl.$modelValue;
      };
    }
  };
};

app.directive('dynamicFormSelector', ['DynamicFormRestService', 'AuthDataService', DynamicFormSelector]);
